import ProcessoService from "./../_services/ProcessoService";
import { erroArrayToString } from "@/utils/trataErroRetornoApi";
import { processoModel } from "./../_model/index";
import validaProcesso from "@/utils/validaProcesso";
import { normalizeProcessos } from "@/utils/normalizeProcesso";

// Remove máscara (. - /) de campos que compartilham busca por Nome/CPF, evitando
// que a API deixe de encontrar registros quando o usuário digita o CPF/CNPJ formatado
const CAMPOS_COM_MASCARA_DOCUMENTO = ["cliente", "acionado", "captador"];

function limpaMascaraFiltro(filter) {
  const filtroLimpo = { ...filter };
  CAMPOS_COM_MASCARA_DOCUMENTO.forEach((campo) => {
    const valor = filtroLimpo[campo];
    if (typeof valor !== "string") return;

    const valorTrim = valor.trim();
    const pareceDocumento =
      /^[\d.\-/\s]+$/.test(valorTrim) && /[.\-/]/.test(valorTrim);
    if (!pareceDocumento) return;

    filtroLimpo[campo] = valorTrim.replace(/[^\d]/g, "");
  });
  return filtroLimpo;
}

const state = {
  stateButton: null,
  loading: false,
  loadingStore: false,
  loadingPendProcesso: false,
  processos: [],
  currentPage: null,
  urlFirstPage: null,
  urlNextPage: null,
  urlPrevPage: null,
  urlLastPage: null,
  urlPath: null,
  total: null,
  vlTotal: null,
  processoSelecionado: undefined,
  pendencia_processo: [],
  erros: "",
  filter: {},
  sort: "dt_inclusao asc, cliPess.nm_pessoa asc",
  fileSelected: null,
};

const getters = {
  GET_PROCESSOS: (state) => state.processos,
  GET_URL_PATH: (state) => state.urlPath,
  GET_ERROS: (state) => state.erros,
  GET_FILE: (state) => state.fileSelected,
  PROCESSO_SELECIONADO: (state) => state.processoSelecionado,
};

const mutations = {
  SET_STATE_BUTTON: (state, value) => {
    state.stateButton = value;
  },

  SET_FILE: (state, file) => {
    state.fileSelected = file;
  },

  SET_LOADING_STORE: (state, ativo) => {
    state.loadingStore = ativo ? ativo : false;
  },

  PROCESSO_SELECTED: (state, { processo }) => {
    state.processoSelecionado = Object.assign({}, processo);
  },

  PENDENCIA_PROCESSO: (state, { pendencia_processo }) => {
    state.pendencia_processo = JSON.parse(JSON.stringify(pendencia_processo));
  },

  SET_PROCESSO: (state, { processos }) => {
    const cloned = JSON.parse(JSON.stringify(processos));
    const isPaginado = cloned && Array.isArray(cloned.data);

    state.processos = isPaginado
      ? { ...cloned, data: normalizeProcessos(cloned.data) }
      : normalizeProcessos(Array.isArray(cloned) ? cloned : []);

    state.urlFirstPage = isPaginado ? cloned.first_page_url : null;
    state.urlPrevPage = isPaginado ? cloned.prev_page_url : null;
    state.urlNextPage = isPaginado ? cloned.next_page_url : null;
    state.urlLastPage = isPaginado ? cloned.last_page_url : null;
    state.urlPath = isPaginado ? cloned.path : null;
    state.currentPage = isPaginado ? cloned.current_page : null;
    state.total = isPaginado ? cloned.total : null;
  },

  SET_VLTOTAL: (state, { valor_total }) => {
    state.vlTotal = valor_total;
  },

  SET_ERROS: (state, erros) => {
    state.erros = erros.erros;
  },

  SET_FILTER: (state, filter) => {
    state.filter = limpaMascaraFiltro(filter);
  },

  SET_SORT: (state, sort) => {
    state.sort = sort;
  },

  ERASE_ERROS: (state) => {
    state.erros = "";
  },

  RESET_SELECTED: (state) => (state.processoSelecionado = undefined),

  LOADING_PENDENCIA: (state, status) => {
    state.loadingPendProcesso = status;
  },
};

const actions = {
  GET_FILTER: async ({ commit, state }) => {
    commit("SET_PROCESSO", { processos: [] });
    commit("ERASE_ERROS");
    await ProcessoService.getProcessosFilter({
      filter: state.filter,
      sort: { field: state.sort },
    })
      .then((response) => {
        if (response.data.status) {
          let processos = response.data.processos
            ? response.data.processos
            : [];
          commit("SET_PROCESSO", { processos: processos ? processos : [] });
          commit("SET_VLTOTAL", {
            valor_total: response.data.total ? response.data.total : "",
          });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar API" });
        //reject(error)
      });
  },

  GET_PROCESSOS: async ({ commit }) => {
    commit("SET_PROCESSO", { processos: [] });
    commit("ERASE_ERROS");
    await ProcessoService.getProcessosFilter({})
      .then((response) => {
        if (response.data.status) {
          commit("SET_PROCESSO", {
            processos: response.data.processos ? response.data.processos : [],
          });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar API" });
        //reject(error)
      });
  },

  PAGINATE_PROCESSOS: async ({ commit }, url) => {
    commit("ERASE_ERROS");
    await ProcessoService.postPagination(url, {
      filter: state.filter,
      sort: { field: state.sort },
    })
      .then((response) => {
        if (response.data.status) {
          commit("SET_PROCESSO", {
            processos: response.data.processos ? response.data.processos : [],
          });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar api" });
        reject(error);
      });
  },

  GET_PROCESSO: async ({ commit }, id) => {
    commit("ERASE_ERROS");
    await ProcessoService.getProcesso(id)
      .then((response) => {
        if (response.data.status) {
          let processo = response.data.processo;
          commit("PROCESSO_SELECTED", { processo });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar api" });
        reject(error);
      });
  },

  GET_PENDENCIAPROCESSO: async ({ commit }, filter) => {
    commit("LOADING_PENDENCIA", true);
    commit("ERASE_ERROS");
    commit("PENDENCIA_PROCESSO", { pendencia_processo: [] });
    if (!filter.idProcesso || !(filter.idProcesso > 0))
      filter.idProcesso = null;
    if (!filter.idCategoria || !(filter.idCategoria > 0))
      filter.idCategoria = null;
    await ProcessoService.getPendenciaProcesso(filter)
      .then((response) => {
        if (response.data.status) {
          commit("PENDENCIA_PROCESSO", {
            pendencia_processo: response.data.pendencia_processo,
          });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar api" });
        reject(error);
      })
      .finally(() => commit("LOADING_PENDENCIA", false));
  },

  STORE_PROCESSO: async ({ commit, dispatch, state }, processo) => {
    commit("ERASE_ERROS");
    try {
      commit("SET_LOADING_STORE", true);
      if (!processo.id || !(processo.id > 0)) {
        var response = await ProcessoService.postProcesso(processo);
      } else {
        var response = await ProcessoService.putProcesso(processo.id, processo);
      }

      if (response.data.status) {
        commit("PROCESSO_SELECTED", { processo: response.data.processo });

        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch(
            "PAGINATE_PROCESSOS",
            `${state.urlPath}?page=${state.currentPage}`
          );
        } else {
          await dispatch("GET_FILTER");
        }
      } else if (!response.data.status && response.data.validacao) {
        var erros = erroArrayToString(response.data.erros);
        commit("SET_ERROS", { erros: erros });
      } else if (response.data.erro) {
        commit("SET_ERROS", { erros: response.data.erro });
      }
    } catch (error) {
      console.log(error);
      commit("SET_ERROS", { erros: "Erro ao acessar api" });
      reject(error);
    } finally {
      commit("SET_LOADING_STORE", false);
    }
  },

  DELETE_PROCESSO: async ({ commit, dispatch, state }, processo) => {
    commit("ERASE_ERROS");
    try {
      var response = await ProcessoService.deleteProcesso(processo.id);

      if (response.data.status) {
        if (state.urlPrevPage || state.urlNextPage) {
          await dispatch(
            "PAGINATE_PROCESSOS",
            `${state.urlPath}?page=${state.currentPage}`
          );
        } else {
          await dispatch("GET_FILTER");
        }
      } else if (response.data.erro) {
        commit("SET_ERROS", { erros: response.data.erro });
      }
    } catch (error) {
      console.log(error);
      commit("SET_ERROS", { erros: "Erro ao acessar api" });
      reject(error);
    }
  },

  PROCESSO_SELECTED: async ({ dispatch, commit }, id) => {
    commit("PENDENCIA_PROCESSO", { pendencia_processo: {} });
    if (id > 0) {
      try {
        await dispatch("GET_PROCESSO", id);
      } catch (error) {
        reject(error);
      }
    } else {
      var obj = new processoModel.processo();
      await commit("PROCESSO_SELECTED", { processo: obj });
    }
  },

  RESET_SELECTED: ({ commit }) => {
    commit("RESET_SELECTED");
    commit("PENDENCIA_PROCESSO", { pendencia_processo: {} });
  },

  CLONAR_ITEM: async ({ commit }, { id, gerarJuridico }) => {
    commit("ERASE_ERROS");

    /*
    A opção Gerar Processo Jurídico só estará disponível para processos ADM quando o status for 'ANALISE_JURIDICA'
    e 'NEGADO', no entanto, só irá alterar o status para 'ARQUIVO' quando o status atual for 'ANALISE_JURIDICA'.
    */
    await ProcessoService.getProcesso(id)
      .then((response) => {
        if (response.data.status) {
          let processo = response.data.processo;
          let status = processo.statusprocesso_id;
          processo.id_clone = id;
          processo.id = null;
          processo.pericia_dispensada = true;
          processo.dt_pericia = null;
          processo.dt_inclusao = null;
          gerarJuridico
            ? (processo.tipoprocesso_id = 2)
            : (processo.tipoprocesso_id = processo.tipoprocesso_id);
          processo.categoriaprocesso_id = null;
          processo.statusprocesso_id = validaProcesso.status.CADASTRO;
          if (gerarJuridico) {
            processo.processo_parent = {
              id,
              statusprocesso_id:
                status == validaProcesso.status.ANALISE_JURIDICA
                  ? validaProcesso.status.ARQUIVO
                  : status,
            };
          }
          commit("PROCESSO_SELECTED", { processo: processo });
        } else if (response.data.erro) {
          commit("SET_ERROS", { erros: response.data.erro });
        }
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar api" });
        reject(error);
      });
  },

  DOWNLOAD_EXPORT: async ({ commit, state }) => {
    commit("ERASE_ERROS");
    await ProcessoService.exportProcessos({
      filter: state.filter,
      sort: { field: state.sort },
    })
      .then((response) => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", "processos.xlsx");
        document.body.appendChild(fileLink);
        fileLink.click();
      })
      .catch((error) => {
        console.log(error);
        commit("SET_ERROS", { erros: "Erro ao acessar API" });
        //reject(error)
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/views/Processo/_store/index.js